module.exports = __webpack_public_path__ + "public/img/emptyData.956bc8ba.png";